/**
 * Get a user-facing error message from an API catch reason (e.g. Axios error).
 * Always returns something specific when possible; never the generic "software error" unless unavoidable.
 */
export function getErrorMessage(reason) {
	const status = reason && reason.response && reason.response.status;
	const data = reason && reason.response && reason.response.data;

	// Server responded with a body
	if (data) {
		// Backend error helper returns { message, code }
		if (typeof data.message === "string" && data.message.trim()) {
			const msg = data.message.trim();
			return status ? `${msg} (HTTP ${status})` : msg;
		}
		// OpenAPI sometimes returns { error: [{ message }] }
		if (Array.isArray(data.error) && data.error.length > 0 && data.error[0].message) {
			const msg = String(data.error[0].message);
			return status ? `${msg} (HTTP ${status})` : msg;
		}
		// Single string error field
		if (typeof data.error === "string" && data.error.trim()) {
			return status ? `${data.error.trim()} (HTTP ${status})` : data.error.trim();
		}
		// Response but no message – show status
		if (status) return `Request failed (HTTP ${status}). Check backend logs for details.`;
	}

	// No response (network error, timeout, CORS, connection refused, etc.)
	if (reason && reason.message && typeof reason.message === "string") {
		const m = reason.message.trim();
		if (m && m.length < 300) return m;
	}
	// Response body might be HTML or plain text (e.g. proxy 502)
	if (data && typeof data === "string" && data.length < 300) {
		return status ? `Request failed (HTTP ${status}): ${data}` : data;
	}

	// Last resort: still show something useful
	if (reason && reason.response) {
		const s = reason.response.status;
		return `Request failed (HTTP ${s}). Open browser Console (F12) for details.`;
	}
	if (reason && typeof reason.toString === "function" && reason.toString() !== "[object Object]") {
		return reason.toString();
	}
	return "Request failed. Open browser Console (F12) for details.";
}
